import React, { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { getMyInfo } from 'src/apis/userApi';
import useMenuStore from 'src/store/useMenuStore';
import useUiuxStore from 'src/store/useUiuxStore';
import useUserStore from 'src/store/useUserStore';
import { redirectToSignin } from 'src/utils/auth/sessionErrorHandler';
import { validateTokensForAppStart } from 'src/utils/auth/tokenValidator';
import HomeInfo from './homepage/HomeInfo';
import { getCompanyList } from 'src/apis/companyApi';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { useDescLanguageStore } from 'src/store/useDescLanguageStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { Container_KSK2080_R01 } from './mes/KSK/KSK2080_R01/Container_KSK2080_R01';
import { showSuccess } from 'src/utils/toast/toastUtil';
import { useCompanyStore } from 'src/store/useCompanyStore';
import { resetAllStores } from 'src/utils/store/resetAllStores';
import { logout } from 'src/apis/authApi';

interface Props {

}

export const HomeContent = (props: Props) => {

	const { setUserInfo, setUserInCompanyList, initData: initUserData } = useUserStore();
	const { menuList, setMenuList } = useMenuStore();
	const { tabList, activeTab, setActiveTab, addTabList, resetTabList } = useUiuxStore();
	const { companyList, setCompanyList, } = useCompanyStore();
	
	const {
		fetchCommonCode,
		fetchCustomCdCode,
		fetchCompCdCode,
		fetchEmployeeCdCode,
		fetchMenuCdCode,
		fetchOrgCdCode,
		fetchWarehouseCdCode,
		fetchWorkPlaceCdCode,
		fetchItemCdCode,
	} = useCommonCodeStore();
	const { fetchDescLanguageCode } = useDescLanguageStore();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	
	const navigate = useNavigate();

	
	const clearSessionAndMoveSignin = () => {
		// 탭 상태 초기화
		resetTabList();

		// 모든 스토어 초기화
		resetAllStores();

		localStorage.removeItem('access-token');
		localStorage.removeItem('refresh-token');
		localStorage.removeItem('access-exp');
		localStorage.removeItem('refresh-exp');
		navigate('/signin');
	};

	const handleLogoutClick = async () => {
		try {
			await logout();
		} catch (error) {
			console.warn('로그아웃 API 호출 실패:', error);
		} finally {
			clearSessionAndMoveSignin();
		}
	}

	
	useEffect(() => {
		// 앱 시작 시 토큰 검증 (RefreshToken 기준)
		const tokenValidation = validateTokensForAppStart();

		// 토큰이 유효하지 않으면 조용히 로그인 페이지로 이동
		if (!tokenValidation.isValid) {
			console.log(`🔑 토큰 검증 실패: ${tokenValidation.reason} - 로그인 페이지로 이동`);
			redirectToSignin();
			return;
		}

		const initCodeList = async () => {

			const myInfo = (await getMyInfo())?.data?.data;
			setUserInfo(myInfo);

			// 중요: 메뉴 데이터 로드가 완료된 후 초기 탭을 설정합니다.
			if (tabList.length === 0) {
				const fixedTab = {
					key: 'KSK2080_R01',
					title: '공지사항조회',
					component: Container_KSK2080_R01,
					fixed: true
				};
				addTabList(fixedTab);
				setActiveTab(fixedTab);
			}
		}

		initCodeList();
	}, [])

	const refreshMesInfo = useCallback(async (messageNotice: boolean = false) => {
		setLoadingSpinner(true);
		const myInfo = (await getMyInfo())?.data?.data;
		setUserInfo(myInfo);

		const companyList = (await getCompanyList()).data.data;
		
		setCompanyList(companyList);
		if (companyList.length > 0) {
			// setSalesFilterComp(companyList[0].compCd);
			setUserInCompanyList(companyList);
		}

		const [, , , , menuCdList] = await Promise.all([
			fetchCommonCode(),
			fetchCustomCdCode(),
			fetchCompCdCode(),
			fetchEmployeeCdCode(),
			fetchMenuCdCode(),
			fetchOrgCdCode(),
			fetchWarehouseCdCode(),
			fetchWorkPlaceCdCode(),
			fetchItemCdCode(),
			fetchDescLanguageCode(),
		]);
		setMenuList(Array.isArray(menuCdList) ? menuCdList : []);

		if (messageNotice) {
			showSuccess('설정정보를 새로고침하였습니다.');
		}

		setLoadingSpinner(false);
	}, [ 
		setUserInfo,
		setMenuList, 
		setCompanyList, setUserInCompanyList,
		fetchCommonCode, fetchCustomCdCode, fetchCompCdCode, fetchEmployeeCdCode, fetchMenuCdCode, fetchOrgCdCode, fetchWarehouseCdCode, fetchWorkPlaceCdCode, fetchItemCdCode, fetchDescLanguageCode
	])

	
	useEffect(() => {
		// 앱 시작 시 토큰 검증 (RefreshToken 기준)
		const tokenValidation = validateTokensForAppStart();

		// 토큰이 유효하지 않으면 조용히 로그인 페이지로 이동
		if (!tokenValidation.isValid) {
			console.log(`🔑 토큰 검증 실패: ${tokenValidation.reason} - 로그인 페이지로 이동`);
			redirectToSignin();
			return;
		}

		refreshMesInfo(false);

	}, [])
	
	return {
		handleLogoutClick,
		refreshMesInfo
	}
}

export default HomeContent;